import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56607552"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-5" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "total" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, [
  /*#__PURE__*/_createTextVNode("kg CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode("e")
], -1))
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "total" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "€", -1))
const _hoisted_10 = {
  key: 0,
  class: "col-sm-3"
}
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "total" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "€", -1))
const _hoisted_15 = {
  key: 1,
  class: "col-sm-2"
}
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "total" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "€", -1))
const _hoisted_20 = { class: "table" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-20" }, "Material"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-20" }, "Percentage"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-20" }, "CO2e per GRAM"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-20" }, "Fabric Grams"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-20" }, "CO2e Grams")
  ])
], -1))
const _hoisted_22 = { class: "w-20" }
const _hoisted_23 = { class: "w-20" }
const _hoisted_24 = { class: "w-20" }
const _hoisted_25 = { class: "w-20" }
const _hoisted_26 = { class: "w-20" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "table" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Origin Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Destination Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Distance"),
    /*#__PURE__*/_createElementVNode("th", null, "Transport Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Transport CO2e Grams")
  ])
], -1))
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "table" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Origin Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Destination Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Distance"),
    /*#__PURE__*/_createElementVNode("th", null, "Transport Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Transport CO2e Grams")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_production_countries = _resolveComponent("production-countries")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.model.providerPrice > 0 ? 'col-sm-3' : 'col-sm-6')
      }, [
        _createElementVNode("p", _hoisted_2, [
          _createVNode(_component_localized_text, {
            type: "strong",
            localizedKey: "Total",
            text: "Total"
          })
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_localized_text, {
            type: "strong",
            localizedKey: "Footprint",
            text: "Footprint"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.model.totalCO2e), 1),
          _hoisted_5
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.model.providerPrice > 0 ? 'col-sm-4' : 'col-sm-6')
      }, [
        _createElementVNode("p", _hoisted_6, [
          _createVNode(_component_localized_text, {
            type: "strong",
            localizedKey: "Estimated Offsetting",
            text: "Estimated Offsetting"
          })
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_localized_text, {
            type: "strong",
            localizedKey: "Cost In EUR",
            text: "Cost In EUR"
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.model.totalSuggestedCost), 1),
          _hoisted_9
        ])
      ], 2),
      (_ctx.model.providerPrice > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Provider",
                text: "Provider"
              })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Price",
                text: "Price"
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.model.providerPrice), 1),
              _hoisted_14
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.model.providerPrice > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Total",
                text: "Total"
              })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Price",
                text: "Price"
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$filters.currency(_ctx.model.totalPrice)), 1),
              _hoisted_19
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.estimation.data.garment.layers, (layer, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "my-5",
        key: index
      }, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(layer.layerName), 1)
        ]),
        _createElementVNode("table", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layer.fabricCompositions, (fabric, matIndex) => {
              return (_openBlock(), _createElementBlock("tr", { key: matIndex }, [
                _createElementVNode("td", _hoisted_22, _toDisplayString(fabric.rawMaterial.text), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(fabric.percentage) + "%", 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$filters.approximation(fabric.cO2PerGrams)), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$filters.approximation(fabric.totalGrams)), 1),
                _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.$filters.approximation(fabric.totalCO2)), 1)
              ]))
            }), 128))
          ])
        ])
      ]))
    }), 128)),
    _createVNode(_component_production_countries, {
      countries: _ctx.model.countries,
      providerName: _ctx.model.provider ? _ctx.model.provider.text : '',
      providerPrice: _ctx.model.provider ? _ctx.model.providerPrice : 0
    }, null, 8, ["countries", "providerName", "providerPrice"]),
    (_ctx.model.finalTransportation && (_ctx.model.finalTransportation.from || _ctx.model.finalTransportation.to))
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("p", null, [
            _createVNode(_component_localized_text, {
              type: "strong",
              localizedKey: "Final Transportation",
              text: "Final Transportation"
            })
          ]),
          _createElementVNode("table", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(_ctx.model.finalTransportation.from), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.model.finalTransportation.to), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(_ctx.model.finalTransportation.distance)) + "km", 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.model.finalTransportation.type), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(_ctx.model.finalTransportation.totalCO2)), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.model.transportationToCustomer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("p", null, [
            _createVNode(_component_localized_text, {
              type: "strong",
              localizedKey: "Transportation to Retailers/Customer",
              text: "Transportation to Retailers/Customer"
            })
          ]),
          _createElementVNode("table", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(_ctx.model.transportationToCustomer.from), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.model.transportationToCustomer.to), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(_ctx.model.transportationToCustomer.distance)) + "km", 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.model.transportationToCustomer.type), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(_ctx.model.transportationToCustomer.totalCO2)), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}